import {
  DefaultOrganizationalContainerRendererModule
} from './default-organizational-container-renderer/default-organizational-container-renderer.module';

export const carrierWebComponents = [
  DefaultOrganizationalContainerRendererModule,
];
